<template>
  <q-btn
    label="Change Password"
    v-bind="$attrs"
    @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import ChangePasswordModal from './ChangePasswordModal.vue';

export default defineComponent({
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { parent: this, userId: this.userId };
      openModal(ChangePasswordModal, props);
    },
  },
});
</script>
